import { render, staticRenderFns } from "./Simulador.vue?vue&type=template&id=07df03e1&scoped=true&"
import script from "./Simulador.vue?vue&type=script&lang=js&"
export * from "./Simulador.vue?vue&type=script&lang=js&"
import style0 from "./Simulador.vue?vue&type=style&index=0&id=07df03e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07df03e1",
  null
  
)

export default component.exports